import _ from 'lodash'
import * as types from './mutation-types'

export default {
  [types.SET_CATEGORIES] (state, {categories}) {
    state.categories = categories
  },
  [types.SET_MEETING] (state, {meeting}) {
    state.items = [meeting, ...state.items]
  },
  [types.SET_MEETINGS] (state, {meetings}) {
    state.items = meetings
  },
  [types.UPDATE_MEETING] (state, {id, meeting}) {
    const index = _.findIndex(state.items, n => n.id === id)
    state.items[index] = meeting
    state.items = [...state.items]
  },
  [types.SET_SEARCH_PARAMS] (state, {params}) {
    state.searchParams = params
  },
  [types.REMOVE_MEETING] (state, {id}) {
    const index = _.findIndex(state.items, n => n.id === id)
    state.items.splice(index, 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/meetings/mutations.js